import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

export function ftpChart(entries) {
  return {
    _chart: null,
    _observer: null,
    entries,

    init() {
      this.$nextTick(() => this.render());
      this._observer = new MutationObserver(() => this.retheme());
      this._observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    },

    destroy() {
      this._observer?.disconnect();
      this._chart?.destroy();
    },

    theme() {
      const dark = document.documentElement.classList.contains('dark');
      return {
        text: dark ? '#9ca3af' : '#6b7280',
        grid: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
        line: dark ? '#f97316' : '#ea580c',
        fill: dark ? 'rgba(249,115,22,0.10)' : 'rgba(234,88,12,0.08)',
        point: dark ? '#fb923c' : '#c2410c',
        tooltipBg: dark ? '#1f2937' : '#111827',
      };
    },

    render() {
      this._chart?.destroy();
      this._chart = null;

      const canvas = this.$refs.chart;
      if (!canvas) return;

      const t = this.theme();
      const labels = this.entries.map((e) => e.datum);
      const data = this.entries.map((e) => parseFloat(e.waarde));

      this._chart = new Chart(canvas, {
        type: 'line',
        data: {
          labels,
          datasets: [
            {
              label: 'FTP (W)',
              data,
              borderColor: t.line,
              backgroundColor: t.fill,
              pointBackgroundColor: t.point,
              pointRadius: data.length > 90 ? 0 : 2,
              pointHoverRadius: 4,
              borderWidth: 2,
              fill: true,
              tension: 0.3,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: t.tooltipBg,
              padding: 10,
              cornerRadius: 6,
              callbacks: {
                label: (ctx) => `${Math.round(ctx.parsed.y)} W`,
              },
            },
          },
          scales: {
            x: {
              ticks: {
                color: t.text,
                maxTicksLimit: 12,
                callback: function (val, idx) {
                  const d = this.getLabelForValue(val);
                  const dt = new Date(d + 'T00:00:00');
                  return dt.toLocaleDateString('nl-BE', { day: 'numeric', month: 'short' });
                },
              },
              grid: { display: false },
            },
            y: {
              ticks: {
                color: t.text,
                callback: (v) => Math.round(v) + ' W',
              },
              grid: { color: t.grid },
            },
          },
        },
      });
    },

    retheme() {
      this.render();
    },
  };
}
